import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import "./Sidebar.css";

const Sidebar = ({ gu, systemYN, onMenuClick }) => {
  return (
    <div className="sidebar">
      {/* Dashboard 메뉴 */}
      <div className="sidebar-item">
        <FontAwesomeIcon icon={faHome} className="menu-icon" />
        <span>Dashboard</span>
        <div className="submenu">
          <Link to="/Dashboard" className="submenu-item" onClick={() => onMenuClick('/Dashboard')}>Dashboard</Link>
        </div>
      </div>

      {/* 주문관리 메뉴 */}
      <div className="sidebar-item">
        <FontAwesomeIcon icon={faClipboardList} className="menu-icon" />
        <span>주문관리</span>
        <div className="submenu">
          <Link to="/OrderRegist" className="submenu-item" onClick={() => onMenuClick('/OrderRegist')}>주문등록</Link>
          <Link to="/OrderRegist_individual" className="submenu-item" onClick={() => onMenuClick('/OrderRegist_individual')}>주문등록(개별)</Link>
          <Link to="/OrderList" className="submenu-item" onClick={() => onMenuClick('/OrderList')}>주문조회</Link>
          {gu === '2' && systemYN === 'N' && (
            <Link to="/OrderTechnician" className="submenu-item" onClick={() => onMenuClick('/OrderTechnician')}>기공사관리</Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
